module.exports = __webpack_public_path__ + "img/seta-right.7b800712.svg";